var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 60,
  viewBox: "0 0 52 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M52 29.828a19.3 19.3 0 0 1-4.336.514c-7.484 0-13.246-5.288-13.246-14.48 0-4.506 1.722-6.85 4.158-6.85 2.316 0 3.861 2.103 3.861 6.369 0 2.426-.642 5.084-1.116 6.656 0 0 2.306 4.07 8.612 2.821C51.273 21.851 52 17.957 52 14.54 52 5.347 47.367 0 38.873 0c-8.731 0-13.84 6.79-13.84 15.742 0 8.869 4.099 16.482 10.858 19.95-2.842 5.75-6.459 10.816-10.23 14.633-6.842-8.367-13.028-19.53-15.566-41.313H0c4.664 36.28 18.563 47.83 22.238 50.049 2.079 1.262 3.869 1.202 5.77.12 2.983-1.717 11.943-10.778 16.91-21.392A33 33 0 0 0 52 36.97z"
})));
export default SvgChannelVine;